<template>
  <div id="app" class="min-h-screen bg-background text-foreground selection:bg-primary selection:text-primary-foreground">
    <router-view />
  </div>
</template>

<script>
import "./styles/globals.css";
import { onMounted } from 'vue';

export default {
  name: "App",
  setup() {
    onMounted(() => {
      // Initialize theme if needed. Default to dark for dark feel, or respect user preference
      if (
        localStorage.theme === 'dark' ||
        (!('theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)
      ) {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
    });
  }
};
</script>
<!-- 
<style>
</style> -->
